import { render, staticRenderFns } from "./ReferHemodialysis.vue?vue&type=template&id=601387c9"
import script from "./ReferHemodialysis.vue?vue&type=script&lang=js"
export * from "./ReferHemodialysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports